import React from "react";
import VenueDetailsBase from "@components/V3/VenueDetails/VenueDetailsBase";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const VenueDetailPage = () => {

    return (
        <VersionedLayout>
            <VenueDetailsBase />
        </VersionedLayout>
    );
};

export default VenueDetailPage;
